import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import { ShareState } from "source/app/services/UI/State/ShareState";
import { useEffect } from "react";
import { SetState } from "source/app/services/UI/State/SetState";

export function RouterNavigationTarget() {
    const [target, setTarget] = React.useState<string>(``);

    const navigate = useNavigate();

    useEffect(() => {
        if (target !== ``) {
            console.log(`[Routing] navigating to '${target}'`);
            navigate(target);
            setTarget(``);
        }
    }, [navigate, target]);

    ShareState(
        ESharedFunction.RouterNavigationTarget_Target,
        target,
        setTarget
    );

    return <div id="routerNavigationTarget" />;
}

export function NavigateTo(url: string) {
    SetState(ESharedFunction.RouterNavigationTarget_Target, url);
}
